import { render, staticRenderFns } from "./FixedBlock.vue?vue&type=template&id=2aea53f0&"
import script from "./FixedBlock.vue?vue&type=script&lang=js&"
export * from "./FixedBlock.vue?vue&type=script&lang=js&"
import style0 from "./FixedBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports